import api from "src/apis/api"

// ── Pipelines (with nested stages) ───────────────────────────────────────────
// Deals only ever live on `deal`-type pipelines. The lead funnel is a separate
// `lead`-type pipeline whose stages hold Leads, not Deals — including it here
// would surface a pipeline that always returns an empty deal list.
export async function fetchPipelines() {
  const { data } = await api.get("/api/v1/pipelines", { params: { entity_type: "deal" } })
  return data.pipelines || []
}

// ── Deals ────────────────────────────────────────────────────────────────────
export async function fetchDeals({
  page = 1, per_page = 100, pipeline_id = "", stage_id = "",
  status = "", owner_id = "", q = "",
} = {}) {
  const params = new URLSearchParams()
  params.set("page", page)
  params.set("per_page", per_page)
  if (pipeline_id) params.set("pipeline_id", pipeline_id)
  if (stage_id)    params.set("stage_id", stage_id)
  if (status)      params.set("status", status)
  if (owner_id)    params.set("owner_id", owner_id)
  if (q)           params.set("q", q)

  const { data } = await api.get(`/api/v1/deals?${params}`)
  return data
}

export async function fetchDeal(id) {
  const { data } = await api.get(`/api/v1/deals/${id}`)
  return data.deal
}

export async function createDeal(payload) {
  const { data } = await api.post("/api/v1/deals", { deal: payload })
  return data.deal
}

export async function updateDeal(id, payload) {
  const { data } = await api.patch(`/api/v1/deals/${id}`, { deal: payload })
  return data.deal
}

export async function deleteDeal(id) {
  const { data } = await api.delete(`/api/v1/deals/${id}`)
  return data
}

// ── Transitions ──────────────────────────────────────────────────────────────
export async function changeDealStage(id, stageId, reason) {
  const { data } = await api.post(`/api/v1/deals/${id}/change_stage`, { stage_id: stageId, reason })
  return data.deal
}

export async function winDeal(id) {
  const { data } = await api.post(`/api/v1/deals/${id}/win`)
  return data.deal
}

export async function loseDeal(id, reason) {
  const { data } = await api.post(`/api/v1/deals/${id}/lose`, { reason })
  return data.deal
}
